import { BaseEntityLineChart } from '../../../components/Charts';
import { useAdmissionMethodsLineChart } from '../hooks/useAdmissionMethodsChart';
import { useAppSelector } from '../../../store/hooks';

interface AdmissionMethodsChartProps {
	height?: number;
}

export function AdmissionMethodsLineChart({ height = 400 }: AdmissionMethodsChartProps) {
	const selectedFaculty = useAppSelector((state) => state.filters.selectedFaculty);

	const { nivoData, isLoading, error } = useAdmissionMethodsLineChart({
		filters: {
			maKhoa: selectedFaculty ? [selectedFaculty] : undefined
		}
	});

	return (
		<BaseEntityLineChart
			height={height}
			title="Biểu đồ Sinh viên theo Phương thức xét tuyển"
			downloadFilename="bieu-do-phuong-thuc-tuyen-sinh"
			entityLabel="Chọn phương thức"
			entityPlaceholder="Tất cả phương thức"
			legendMarginRight={230}
			nivoData={nivoData}
			isLoading={isLoading}
			error={error}
		/>
	);
}
